"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigpopReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var BigpopupAction_1 = require("@/pages/common/actions/BigpopupAction");
var BigPopup_init_1 = require("@/pages/common/states/BigPopup.init");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
exports.bigpopReducer = function (state, action) {
    if (state === void 0) { state = BigPopup_init_1.defaultBigPopupState; }
    switch (action.type) {
        case typesafe_actions_1.getType(BigpopupAction_1.default.onSetMessage): {
            var message = {
                title: action.payload ? action.payload.title : '',
                caption: action.payload ? action.payload.caption : '',
                body: action.payload ? action.payload.body : [],
                type: action.payload ? action.payload.type : BigPopupState_1.BigPopupType.SUCCESS,
            };
            return __assign(__assign({}, state), message);
        }
        case typesafe_actions_1.getType(BigpopupAction_1.default.onSetActive): {
            return __assign(__assign({}, state), { active: action.payload });
        }
        case typesafe_actions_1.getType(BigpopupAction_1.default.enqueue): {
            var newQueue = __spreadArrays(state.queue, [
                action.payload,
            ]);
            return __assign(__assign({}, state), { body: action.payload.body, queue: newQueue });
        }
        case typesafe_actions_1.getType(BigpopupAction_1.default.dequeue): {
            if (!state.queue.length)
                return state;
            var message = state.queue[0];
            var newQueue = __spreadArrays(state.queue.slice(1));
            return __assign(__assign({}, state), { id: message.id, title: message.title, caption: message.caption, type: message.type, queue: newQueue, action: message.action ? message.action : state.action });
        }
    }
    return state;
};
